import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader, Table, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Popover, PopoverHeader, PopoverBody, Spinner, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import { FileText, Edit2, Check, X, Eye, Download, Tag, Layers } from 'react-feather';
import axios from 'axios';
import API_BASE_URL from '../../../../Config/api';
import authHeader from '../../../Customer/authHeader';

const Invoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deliveryModal, setDeliveryModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [savingPayment, setSavingPayment] = useState(false);
  const [proofOfPayment, setProofOfPayment] = useState(null);
  const [paymentNotes, setPaymentNotes] = useState('');
  const [paymentType, setPaymentType] = useState('');
  const [editingShippedDate, setEditingShippedDate] = useState(null);
  const [newShippedDate, setNewShippedDate] = useState('');
  const [editingInvoiceDate, setEditingInvoiceDate] = useState(null);
  const [newInvoiceDate, setNewInvoiceDate] = useState('');
  const [customerCreditNotes, setCustomerCreditNotes] = useState({});
  const [creditNotePopover, setCreditNotePopover] = useState(null);
  const [customEurAmounts, setCustomEurAmounts] = useState({});
  const [editingRate, setEditingRate] = useState(null);
  const [customRates, setCustomRates] = useState({});
  const [applyingCreditNote, setApplyingCreditNote] = useState(null);
  const [paymentHistoryPopover, setPaymentHistoryPopover] = useState(null);
  const [invoicePayments, setInvoicePayments] = useState({});
  const [currencyModal, setCurrencyModal] = useState(false);
  const [currencyModalInvoice, setCurrencyModalInvoice] = useState(null);
  const [targetCurrency, setTargetCurrency] = useState('EUR');
  const [targetRate, setTargetRate] = useState('');
  const [savingInvoiceCurrency, setSavingInvoiceCurrency] = useState(false);
  const [companyModal, setCompanyModal] = useState(false);
  const [companyModalInvoice, setCompanyModalInvoice] = useState(null);
  const [companyForm, setCompanyForm] = useState({});
  const [companyGlobal, setCompanyGlobal] = useState({});
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [savingCompany, setSavingCompany] = useState(false);
  const [loadingPayments, setLoadingPayments] = useState(null);
  const [shippingModal, setShippingModal] = useState(false);
  const [shippingDate, setShippingDate] = useState('');
  const [shippingDocuments, setShippingDocuments] = useState([]);
  const [deliveryDocuments, setDeliveryDocuments] = useState([]);
  const [trackingLink, setTrackingLink] = useState('');
  const [shippingOrder, setShippingOrder] = useState(null);
  const [statusFilter, setStatusFilter] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'invoice_id', direction: 'desc' });

  // Delivery tag states
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [deliveryTagModal, setDeliveryTagModal] = useState(false);
  const [deliveryTags, setDeliveryTags] = useState([]);
  const [selectedDeliveryTag, setSelectedDeliveryTag] = useState('');
  const [newTagName, setNewTagName] = useState('');
  const [newTagMonth, setNewTagMonth] = useState('');
  const [showNewTagForm, setShowNewTagForm] = useState(false);
  const [deliveryTagFilter, setDeliveryTagFilter] = useState('All');

  // Payment reminder settings states
  const [reminderSettings, setReminderSettings] = useState({ reminder_days: 30, recipient_email: '', enabled: 1 });
  const [showReminderConfig, setShowReminderConfig] = useState(false);
  const [reminderLogs, setReminderLogs] = useState([]);
  const [savingReminder, setSavingReminder] = useState(false);

  // Custom CSS to fix table hover text color issue
  const tableStyles = `
    .invoices-table.table-striped.table-hover tbody tr:hover th,
    .invoices-table.table-striped.table-hover tbody tr:hover td {
      color: #212529 !important;
      background-color: rgba(0, 0, 0, 0.075);
    }
    .invoice-id-link {
      color: #007bff !important;
      text-decoration: none !important;
      font-weight: bold !important;
      cursor: pointer;
    }
    .invoice-id-link:hover {
      color: #0056b3 !important;
      text-decoration: underline !important;
    }
    .invoices-table.table-striped.table-hover tbody tr:hover .invoice-id-link {
      color: #0056b3 !important;
    }
    .selected-row {
      background-color: rgba(0, 123, 255, 0.15) !important;
    }
    .delivery-tag-badge {
      font-size: 11px;
      padding: 4px 8px;
    }
    .sortable-header {
      cursor: pointer;
      user-select: none;
    }
    .sortable-header:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  `;

  useEffect(() => {
    fetchInvoices();
    fetchDeliveryTags();
    fetchReminderSettings();
  }, []);

  const fetchDeliveryTags = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/delivery-tags`);
      setDeliveryTags(response.data.tags || []);
    } catch (err) {
      console.error('Error fetching delivery tags:', err);
    }
  };

  const fetchReminderSettings = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/payment-reminder-settings`);
      setReminderSettings(response.data);
    } catch (err) {
      console.error('Error fetching reminder settings:', err);
    }
  };

  const fetchReminderLogs = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/payment-reminder-logs`);
      setReminderLogs(response.data.logs || []);
    } catch (err) {
      console.error('Error fetching reminder logs:', err);
    }
  };

  const handleSaveReminderSettings = async () => {
    setSavingReminder(true);
    try {
      await axios.put(`${API_BASE_URL}/api/payment-reminder-settings`, {
        reminder_days: reminderSettings.reminder_days,
        recipient_email: reminderSettings.recipient_email,
        enabled: reminderSettings.enabled
      });
      alert('Payment reminder settings saved successfully!');
    } catch (err) {
      console.error('Error saving reminder settings:', err);
      alert('Failed to save settings: ' + (err.response?.data?.error || err.message));
    } finally {
      setSavingReminder(false);
    }
  };

  const fetchInvoices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/all-invoices`);
      console.log('Fetched invoices:', response.data.invoices);
      setInvoices(response.data.invoices);

      // Fetch credit notes for all customers
      const customerIds = [...new Set(response.data.invoices.map(inv => inv.customer_id).filter(Boolean))];
      const creditNotesData = {};
      for (const customerId of customerIds) {
        try {
          const cnResponse = await axios.get(`${API_BASE_URL}/api/customers/${customerId}/credit-notes`, authHeader());
          if (cnResponse.data && cnResponse.data.length > 0) {
            creditNotesData[customerId] = cnResponse.data;
          }
        } catch (err) {
          console.error(`Error fetching credit notes for customer ${customerId}:`, err);
        }
      }
      setCustomerCreditNotes(creditNotesData);
      setError(null);
    } catch (err) {
      console.error('Error fetching invoices:', err);
      setError('Failed to fetch invoices');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = (invoiceId) => {
    // Download Invoice PDF
    window.open(`${API_BASE_URL}/api/generate-invoice-pdf/${invoiceId}`, '_blank');
  };

  const handleDownloadPDFWithHSN = (invoiceId) => {
    window.open(`${API_BASE_URL}/api/generate-invoice-pdf-with-hsn/${invoiceId}`, '_blank');
  };

  const handleDownloadXLS = (invoiceId) => {
    window.open(`${API_BASE_URL}/api/generate-invoice-xls/${invoiceId}`, '_blank');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getCurrencySymbol = (currency) => {
    const symbols = {
      'EUR': '€',
      'USD': '$',
      'GBP': '£',
      'INR': '₹'
    };
    return symbols[currency] || '€';
  };

  const getConversionRate = (fromCurrency, toCurrency) => {
    if (fromCurrency === toCurrency) return 1;

    // Conversion rates (relative to EUR as base)
    const rates = {
      'EUR': 1,
      'GBP': 0.86,   // 1 EUR = 0.86 GBP
      'INR': 91.5    // 1 EUR = 91.5 INR
    };

    // Calculate rate from source to target currency
    const rate = rates[toCurrency] / rates[fromCurrency];
    return rate;
  };

  const convertCurrency = (amount, fromCurrency, toCurrency, customRate = null) => {
    if (fromCurrency === toCurrency) return amount;

    const rate = customRate !== null ? customRate : getConversionRate(fromCurrency, toCurrency);
    return parseFloat(amount) * rate;
  };

  const formatCurrency = (amount, currency = 'EUR') => {
    if (!amount) return `${getCurrencySymbol(currency)}0.00`;
    return `${getCurrencySymbol(currency)}${parseFloat(amount).toFixed(2)}`;
  };

  // Invoice display currency: a presentation-only conversion of the
  // invoice's real total (native to invoice.currency) at a fixed,
  // admin-entered rate — it never changes what was actually invoiced or
  // paid. NULL display_currency (every invoice predating this feature)
  // means "show in the order's own currency". Deliberately NOT used for the
  // payment-recording modal below, which must always show/accept the real
  // native-currency amount.
  const getInvoiceDisplayCurrency = (invoice) => invoice?.display_currency || invoice?.currency || 'EUR';
  const getInvoiceDisplayAmount = (invoice, amount) => {
    const rate = invoice?.display_currency ? (parseFloat(invoice.fx_rate) || 1) : 1;
    return (parseFloat(amount) || 0) * rate;
  };
  const formatInvoiceCurrency = (invoice, amount) =>
    formatCurrency(getInvoiceDisplayAmount(invoice, amount), getInvoiceDisplayCurrency(invoice));

  const toggleDeliveryModal = () => {
    setDeliveryModal(!deliveryModal);
    if (deliveryModal) {
      setSelectedInvoice(null);
      setDeliveryDate('');
      setDeliveryDocuments([]);
    }
  };

  const togglePaymentModal = () => {
    setPaymentModal(!paymentModal);
    if (paymentModal) {
      setSelectedInvoice(null);
      setPaymentDate('');
      setPaymentAmount('');
      setProofOfPayment(null);
      setPaymentNotes('');
      setPaymentType('');
    }
  };

  const handleMarkDelivered = (invoice) => {
    setSelectedInvoice(invoice);
    setDeliveryModal(true);
  };

  const handleMarkPaid = (invoice) => {
    setSelectedInvoice(invoice);
    setPaymentModal(true);
  };

  const handleSaveDelivery = async () => {
    if (!deliveryDate) {
      alert('Please select a delivery date');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('deliveryDate', deliveryDate);

      if (deliveryDocuments.length > 0) {
        deliveryDocuments.forEach((file) => {
          formData.append('deliveryDocuments', file);
        });
      }

      await axios.post(`${API_BASE_URL}/api/mark-invoice-delivered/${selectedInvoice.invoice_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // Update local data
      const updatedInvoices = invoices.map(inv => {
        if (inv.invoice_id === selectedInvoice.invoice_id) {
          return {
            ...inv,
            is_delivered: 1,
            delivered_date: deliveryDate,
            order_status: 'Delivered'
          };
        }
        return inv;
      });

      setInvoices(updatedInvoices);
      alert(`Invoice marked as delivered successfully!${reminderSettings.enabled ? `\n\nA payment reminder email will be sent automatically after ${reminderSettings.reminder_days} days.` : ''}`);
      toggleDeliveryModal();
    } catch (err) {
      console.error(err);
      alert('Error marking as delivered: ' + (err.response?.data?.error || err.message));
    }
  };

  // Order statuses available for invoices
  const invoiceOrderStatuses = ['New Order', 'In Production', 'Ready to Ship', 'Shipped', 'Delivered', 'Deposit Paid', 'Paid in Full', 'Cancelled'];

  const getStatusColor = (status) => {
    switch (status) {
      case 'New Order':
        return 'primary';
      case 'In Production':
        return 'secondary';
      case 'Ready to Ship':
        return 'info';
      case 'Shipped':
        return 'info';
      case 'Delivered':
        return 'success';
      case 'Deposit Paid':
        return 'warning';
      case 'Paid in Full':
        return 'success';
      case 'Cancelled':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  const getStatusCounts = () => {
    return {
      all: invoices.length,
      'Invoice Generated': invoices.filter(o => o.invoice_generated === 1).length,
      'In Production': invoices.filter(o => o.order_status === 'In Production').length,
      'Ready to Ship': invoices.filter(o => o.order_status === 'Ready to Ship').length,
      'Shipped': invoices.filter(o => o.order_status === 'Shipped').length,
      'Delivered': invoices.filter(o => o.order_status === 'Delivered').length,
      'Fully Paid': invoices.filter(o => o.is_paid === 1).length,
      'Deposit Paid': invoices.filter(o => o.is_paid !== 1 && (o.total_paid || 0) > 0 && o.order_status === 'Deposit Paid').length,
      'Partially Paid': invoices.filter(o => o.is_paid !== 1 && (o.total_paid || 0) > 0 && o.order_status !== 'Deposit Paid').length,
      'Unpaid': invoices.filter(o => o.is_paid !== 1 && (o.total_paid || 0) === 0).length
    };
  };

  const getDeliveryTagCounts = () => {
    const counts = {
      all: invoices.length,
      none: invoices.filter(inv => !inv.delivery_tag_id).length
    };
    deliveryTags.forEach(tag => {
      counts[tag.id] = invoices.filter(inv => inv.delivery_tag_id === tag.id).length;
    });
    return counts;
  };

  const getFilteredInvoices = () => {
    let filtered = invoices;

    // Apply delivery tag filter
    if (deliveryTagFilter !== 'All') {
      if (deliveryTagFilter === 'None') {
        filtered = filtered.filter(inv => !inv.delivery_tag_id);
      } else {
        filtered = filtered.filter(inv => inv.delivery_tag_id === parseInt(deliveryTagFilter));
      }
    }

    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.trim().toLowerCase();
      filtered = filtered.filter(inv =>
        inv.invoice_id?.toLowerCase().includes(query)
      );
    }

    // Apply status filter
    if (statusFilter === 'All') {
      return filtered;
    }
    if (statusFilter === 'Invoice Generated') {
      return filtered.filter(inv => inv.invoice_generated === 1);
    }
    if (statusFilter === 'Fully Paid') {
      return filtered.filter(inv => inv.is_paid === 1);
    }
    if (statusFilter === 'Deposit Paid') {
      return filtered.filter(inv => inv.is_paid !== 1 && (inv.total_paid || 0) > 0 && inv.order_status === 'Deposit Paid');
    }
    if (statusFilter === 'Partially Paid') {
      return filtered.filter(inv => inv.is_paid !== 1 && (inv.total_paid || 0) > 0 && inv.order_status !== 'Deposit Paid');
    }
    if (statusFilter === 'Unpaid') {
      return filtered.filter(inv => inv.is_paid !== 1 && (inv.total_paid || 0) === 0);
    }
    return filtered.filter(inv => inv.order_status === statusFilter);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortedInvoices = (invoicesToSort) => {
    if (!sortConfig.key) {
      return invoicesToSort;
    }

    return [...invoicesToSort].sort((a, b) => {
      let aValue, bValue;

      switch (sortConfig.key) {
        case 'invoice_id':
          // Extract numeric part for proper sorting (e.g., FARAWS2643 -> 2643)
          const aNum = parseInt(a.invoice_id?.replace(/\D/g, '') || '0');
          const bNum = parseInt(b.invoice_id?.replace(/\D/g, '') || '0');
          aValue = aNum;
          bValue = bNum;
          break;
        case 'invoice_date':
          aValue = new Date(a.invoice_date || a.created_date || 0).getTime();
          bValue = new Date(b.invoice_date || b.created_date || 0).getTime();
          break;
        case 'total_amount':
          aValue = parseFloat(a.total_amount) || 0;
          bValue = parseFloat(b.total_amount) || 0;
          break;
        case 'store_name':
          aValue = (a.store_name || '').toLowerCase();
          bValue = (b.store_name || '').toLowerCase();
          break;
        default:
          return 0;
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) {
      return ' ⇅';
    }
    return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
  };

  const calculateDepositAmount = (invoice) => {
    if (!invoice.deposit_value) return 0;
    if (invoice.deposit_type === 'percentage') {
      const baseAmount = parseFloat(invoice.total_amount) - parseFloat(invoice.shipping_cost || 50);
      return (parseFloat(invoice.deposit_value) / 100) * baseAmount;
    }
    return parseFloat(invoice.deposit_value);
  };

  const handleDownloadReport = () => {
    // Get filtered invoices and sort by payment status (paid first, then by amount paid)
    const dataToExport = [...getFilteredInvoices()].sort((a, b) => {
      const aPaid = a.total_paid || 0;
      const bPaid = b.total_paid || 0;
      // Sort by payment amount descending (orders with payments first)
      return bPaid - aPaid;
    });

    // Create CSV content
    const headers = ['Order ID', 'Store Name', 'VAT/EORI', 'Currency', 'Total Amount', 'Deposit Requested', 'Amount Paid', 'Balance Amount', 'Payment Status', 'Order Status'];

    const rows = dataToExport.map(invoice => {
      const totalAmount = parseFloat(invoice.total_amount) || 0;
      const depositRequested = calculateDepositAmount(invoice);
      const amountPaid = parseFloat(invoice.total_paid) || 0;
      const balanceAmount = totalAmount - amountPaid;
      const currency = invoice.currency || 'EUR';

      let paymentStatus = 'Unpaid';
      if (invoice.is_paid === 1) {
        paymentStatus = 'Fully Paid';
      } else if (amountPaid > 0) {
        paymentStatus = invoice.order_status === 'Deposit Paid' ? 'Deposit Paid' : 'Partially Paid';
      }

      return [
        invoice.invoice_id,
        `"${(invoice.store_name || 'N/A').replace(/"/g, '""')}"`,
        `"${(invoice.vat_eori || '').replace(/"/g, '""')}"`,
        currency,
        totalAmount.toFixed(2),
        depositRequested.toFixed(2),
        amountPaid.toFixed(2),
        balanceAmount.toFixed(2),
        paymentStatus,
        invoice.order_status || 'N/A'
      ];
    });

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `invoices_report_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadSkuReport = async () => {
    try {
      // Download Excel file directly from API
      const response = await axios.get(`${API_BASE_URL}/api/delivery-tag-sku-report`, {
        responseType: 'blob'
      });

      // Create download link
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `delivery_tag_sku_report_${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error downloading SKU report:', err);
      if (err.response?.status === 404) {
        alert('No data available for SKU report. Please assign delivery tags to invoices first.');
      } else {
        alert('Failed to download SKU report: ' + (err.response?.data?.error || err.message));
      }
    }
  };

  const handleDownloadGreenShipmentCSV = async () => {
    if (selectedInvoices.length === 0) {
      alert('Please select at least one invoice');
      return;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/api/green-shipment-csv-data`, {
        invoiceIds: selectedInvoices
      });
      const rows = response.data.rows || [];
      if (rows.length === 0) {
        alert('No line items found for the selected invoices.');
        return;
      }

      // Green format has pipe-delimited fields; escape any pipes inside values.
      const escape = (v) => (v == null ? '' : String(v).replace(/\|/g, '/').replace(/[\r\n]+/g, ' ').trim());

      // Addresses are a single free-text field. Split on commas / newlines,
      // optionally peel a trailing country (no digits) and a trailing
      // postcode token off the last remaining part.
      const splitAddress = (addr) => {
        const raw = (addr || '').trim();
        if (!raw) return { address1: '', town: '', postCode: '', country: '' };

        const parts = raw.split(/[,\n]/).map(p => p.trim()).filter(Boolean);

        // A postcode is either pure digits (239974, 90210-1234), UK-style
        // (SW1A 1AA, EC1A1BB), or a single alphanumeric token containing a digit.
        const isPostcode = (s) => {
          const t = (s || '').trim();
          if (/^\d[\d-]*$/.test(t)) return true;
          if (/^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i.test(t)) return true;
          if (/^[A-Z0-9-]+$/i.test(t) && /\d/.test(t)) return true;
          return false;
        };

        // If the last comma-part has no digits, treat it as Country.
        let country = '';
        let remaining = parts.slice();
        if (remaining.length >= 2 && !/\d/.test(remaining[remaining.length - 1])) {
          country = remaining.pop();
        }

        if (remaining.length === 0) {
          return { address1: '', town: '', postCode: '', country };
        }

        // Try to peel a postcode off the last remaining part.
        const last = remaining[remaining.length - 1];
        let town = '';
        let postCode = '';
        if (isPostcode(last)) {
          postCode = last;
          remaining = remaining.slice(0, -1);
        } else {
          // Peel the last whitespace-separated token if it looks like a postcode
          // (e.g. "Singapore 239974", "London NW1 6XE").
          const mEnd = last.match(/^(.*\S)\s+([A-Z0-9][A-Z0-9 -]*\d[A-Z0-9 -]*)\s*$/i);
          if (mEnd && isPostcode(mEnd[2])) {
            town = mEnd[1].trim();
            postCode = mEnd[2].trim();
            remaining = remaining.slice(0, -1);
          } else {
            // Peel the first token if it looks like a postcode (EU style:
            // "20121 Milano", "75001 Paris").
            const mStart = last.match(/^([A-Z0-9-]+)\s+(.+)$/i);
            if (mStart && isPostcode(mStart[1])) {
              postCode = mStart[1].trim();
              town = mStart[2].trim();
              remaining = remaining.slice(0, -1);
            }
          }
        }

        if (!postCode && !town) {
          // No postcode found anywhere; dump everything into address1.
          return { address1: remaining.join(', '), town: '', postCode: '', country };
        }

        if (!town && remaining.length > 0) {
          // Postcode stood alone in the last part; use the previous comma-part as town.
          town = remaining[remaining.length - 1];
          remaining = remaining.slice(0, -1);
        }

        return { address1: remaining.join(', '), town, postCode, country };
      };

      const headers = ['OrderNumber','CompanyName','Address1','Town','PostCode','Country','Telephone','Email','Product 1','Quantity 1','UnitPrice1','VATNumber'];

      const lines = rows.map(r => {
        const { address1, town, postCode, country } = splitAddress(r.shipping_address);
        const unitPrice = (parseFloat(r.unit_price) || 0).toFixed(2);
        const product = r.sku ? `${r.sku}${r.size ? ` / ${r.size}` : ''}` : (r.title || '');
        return [
          r.order_id,
          r.store_name || '',
          address1,
          town,
          postCode,
          country,
          r.tel || '',
          r.email || '',
          product,
          r.quantity || 0,
          unitPrice,
          r.vat_eori || ''
        ].map(escape).join('|') + '|';
      });

      const csvContent = ['sep=|', headers.join('|') + '|', ...lines].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `green_shipment_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error downloading Green shipment CSV:', err);
      alert('Failed to download Green shipment CSV: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleStatusChange = async (invoice, newStatus) => {
    // If changing to "Shipped", show the shipping modal instead
    if (newStatus === 'Shipped') {
      handleMarkAsShipped(invoice);
      return;
    }

    // If changing to "Delivered", show the delivery modal instead
    if (newStatus === 'Delivered') {
      handleMarkDelivered(invoice);
      return;
    }

    try {
      await axios.put(`${API_BASE_URL}/api/update-order-status/${invoice.order_id}`, {
        status: newStatus
      });

      // Update local data
      const updatedInvoices = invoices.map(inv => {
        if (inv.invoice_id === invoice.invoice_id) {
          return {
            ...inv,
            order_status: newStatus,
            is_delivered: newStatus === 'Delivered' ? 1 : inv.is_delivered
          };
        }
        return inv;
      });

      setInvoices(updatedInvoices);
    } catch (err) {
      console.error('Error updating status:', err);
      alert('Error updating status: ' + (err.response?.data?.error || err.message));
    }
  };

  // Delivery tag selection handlers
  const handleSelectInvoice = (invoiceId) => {
    setSelectedInvoices(prev => {
      if (prev.includes(invoiceId)) {
        return prev.filter(id => id !== invoiceId);
      } else {
        return [...prev, invoiceId];
      }
    });
  };

  const handleSelectAll = (filteredInvoices) => {
    const filteredInvoiceIds = filteredInvoices.map(inv => inv.invoice_id);
    if (selectedInvoices.length === filteredInvoiceIds.length && filteredInvoiceIds.every(id => selectedInvoices.includes(id))) {
      setSelectedInvoices([]);
    } else {
      setSelectedInvoices(filteredInvoiceIds);
    }
  };

  const toggleDeliveryTagModalFn = () => {
    setDeliveryTagModal(!deliveryTagModal);
    if (deliveryTagModal) {
      setSelectedDeliveryTag('');
      setShowNewTagForm(false);
      setNewTagName('');
      setNewTagMonth('');
    }
  };

  const handleCreateNewTag = async () => {
    if (!newTagName || !newTagMonth) {
      alert('Please enter tag name and month');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/delivery-tags`, {
        name: newTagName,
        month: newTagMonth
      });

      setDeliveryTags([response.data.tag, ...deliveryTags]);
      setSelectedDeliveryTag(response.data.tag.id.toString());
      setShowNewTagForm(false);
      setNewTagName('');
      setNewTagMonth('');
      alert('Delivery tag created successfully!');
    } catch (err) {
      console.error('Error creating delivery tag:', err);
      alert('Failed to create delivery tag');
    }
  };

  const handleAssignDeliveryTag = async () => {
    if (selectedInvoices.length === 0) {
      alert('Please select at least one invoice');
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/assign-delivery-tag`, {
        invoiceIds: selectedInvoices,
        deliveryTagId: selectedDeliveryTag ? parseInt(selectedDeliveryTag) : null
      });

      // Update local state
      const tag = deliveryTags.find(t => t.id === parseInt(selectedDeliveryTag));
      const updatedInvoices = invoices.map(invoice => {
        if (selectedInvoices.includes(invoice.invoice_id)) {
          return {
            ...invoice,
            delivery_tag_id: selectedDeliveryTag ? parseInt(selectedDeliveryTag) : null,
            delivery_tag_name: tag?.name || null,
            delivery_tag_month: tag?.month || null
          };
        }
        return invoice;
      });

      setInvoices(updatedInvoices);
      setSelectedInvoices([]);
      toggleDeliveryTagModalFn();
      alert(`Delivery tag ${selectedDeliveryTag ? 'assigned' : 'removed'} successfully!`);
    } catch (err) {
      console.error('Error assigning delivery tag:', err);
      alert('Failed to assign delivery tag');
    }
  };

  const togglePaymentHistoryPopover = async (invoiceId) => {
    if (paymentHistoryPopover === invoiceId) {
      setPaymentHistoryPopover(null);
      return;
    }

    // Fetch payments if not already loaded
    if (!invoicePayments[invoiceId]) {
      setLoadingPayments(invoiceId);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/invoice-payments/${invoiceId}`);
        setInvoicePayments(prev => ({
          ...prev,
          [invoiceId]: response.data.payments || []
        }));
      } catch (err) {
        console.error('Error fetching payments:', err);
        setInvoicePayments(prev => ({
          ...prev,
          [invoiceId]: []
        }));
      } finally {
        setLoadingPayments(null);
      }
    }
    setPaymentHistoryPopover(invoiceId);
  };

  const handleSavePayment = async () => {
    if (savingPayment) return;
    if (!paymentType) {
      alert('Please select a payment type');
      return;
    }

    if (!paymentDate) {
      alert('Please select a payment date');
      return;
    }

    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      alert('Please enter a valid payment amount');
      return;
    }

    setSavingPayment(true);
    try {
      const formData = new FormData();
      formData.append('paymentType', paymentType);
      formData.append('paymentDate', paymentDate);
      formData.append('paymentAmount', paymentAmount);
      if (proofOfPayment) {
        formData.append('proofOfPayment', proofOfPayment);
      }
      formData.append('orderId', selectedInvoice.invoice_id.replace('FARAWS', 'FARAWS'));
      formData.append('notes', paymentNotes);

      const response = await axios.post(`${API_BASE_URL}/api/mark-invoice-paid/${selectedInvoice.invoice_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      // Refresh invoices to get updated payment status
      await fetchInvoices();

      alert(response.data.message || 'Payment recorded successfully!');
      togglePaymentModal();
    } catch (err) {
      console.error(err);
      alert('Error marking as paid: ' + (err.response?.data?.error || err.message));
    } finally {
      setSavingPayment(false);
    }
  };

  const toggleCurrencyModal = () => {
    setCurrencyModal(!currencyModal);
    if (currencyModal) {
      setCurrencyModalInvoice(null);
      setTargetCurrency('EUR');
      setTargetRate('');
    }
  };

  const handleOpenCurrencyModal = (invoice) => {
    const native = invoice.currency || 'EUR';
    const current = invoice.display_currency || native;
    setCurrencyModalInvoice(invoice);
    setTargetCurrency(current);
    setTargetRate(invoice.display_currency ? String(invoice.fx_rate || getConversionRate(native, current)) : '');
    setCurrencyModal(true);
  };

  const handleTargetCurrencyChange = (newCurrency) => {
    setTargetCurrency(newCurrency);
    const native = currencyModalInvoice?.currency || 'EUR';
    setTargetRate(newCurrency === native ? '' : getConversionRate(native, newCurrency).toFixed(4));
  };

  const handleSaveInvoiceCurrency = async () => {
    if (!currencyModalInvoice) return;
    const native = currencyModalInvoice.currency || 'EUR';
    const isNative = targetCurrency === native;

    if (!isNative && (!targetRate || parseFloat(targetRate) <= 0)) {
      alert('Please enter a valid positive exchange rate');
      return;
    }

    setSavingInvoiceCurrency(true);
    try {
      const payload = {
        invoiceId: currencyModalInvoice.invoice_id,
        currency: isNative ? null : targetCurrency,
        rate: isNative ? null : parseFloat(targetRate)
      };
      await axios.post(`${API_BASE_URL}/api/invoice-currency`, payload);

      const updatedInvoices = invoices.map(inv =>
        inv.invoice_id === currencyModalInvoice.invoice_id
          ? { ...inv, display_currency: payload.currency, fx_rate: payload.rate }
          : inv
      );
      setInvoices(updatedInvoices);
      toggleCurrencyModal();
    } catch (err) {
      console.error(err);
      alert('Error updating invoice currency: ' + (err.response?.data?.error || err.message));
    } finally {
      setSavingInvoiceCurrency(false);
    }
  };

  const COMPANY_FIELDS = ['company_name', 'company_address', 'company_email', 'company_vat_no', 'company_eori', 'company_bank_details', 'company_fiscal_rep', 'company_reverse_vat_charge', 'company_zero_rated_goods'];

  const toggleCompanyModal = () => {
    setCompanyModal(!companyModal);
    if (companyModal) {
      setCompanyModalInvoice(null);
      setCompanyForm({});
      setCompanyGlobal({});
    }
  };

  const handleOpenCompanyModal = async (invoice) => {
    setCompanyModalInvoice(invoice);
    setCompanyModal(true);
    setLoadingCompany(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/invoice-company/${invoice.invoice_id}`);
      const overrides = response.data.overrides || {};
      const form = {};
      COMPANY_FIELDS.forEach((f) => { form[f] = overrides[f] || ''; });
      // Tri-state override: '' = use the company setting, '1' = zero-rated,
      // '0' = not zero-rated. (`overrides[f] || ''` above would collapse a
      // stored 0 to '', losing the "explicitly off" choice.)
      form.company_zero_rated_goods = overrides.company_zero_rated_goods == null
        ? '' : String(overrides.company_zero_rated_goods);
      setCompanyForm(form);
      setCompanyGlobal(response.data.global || {});
    } catch (err) {
      console.error('Error loading invoice company details:', err);
      alert('Error loading company details: ' + (err.response?.data?.error || err.message));
      setCompanyModal(false);
    } finally {
      setLoadingCompany(false);
    }
  };

  const handleSaveCompanyDetails = async () => {
    if (!companyModalInvoice) return;
    setSavingCompany(true);
    try {
      await axios.put(`${API_BASE_URL}/api/invoice-company/${companyModalInvoice.invoice_id}`, companyForm);
      alert('Invoice company details updated successfully!');
      toggleCompanyModal();
    } catch (err) {
      console.error('Error saving invoice company details:', err);
      alert('Error saving company details: ' + (err.response?.data?.error || err.message));
    } finally {
      setSavingCompany(false);
    }
  };

  const toggleShippingModal = () => {
    setShippingModal(!shippingModal);
    if (shippingModal) {
      setSelectedInvoice(null);
      setShippingDate('');
      setShippingDocuments([]);
      setTrackingLink('');
    }
  };

  const handleMarkAsShipped = (invoice) => {
    setSelectedInvoice(invoice);
    setShippingDate('');
    setShippingModal(true);
  };

  const handleSaveShipping = async () => {
    if (!shippingDate) {
      alert('Please select a shipping date');
      return;
    }

    try {
      setShippingOrder(selectedInvoice.order_id);

      const formData = new FormData();
      formData.append('shippingDate', shippingDate);
      formData.append('trackingLink', trackingLink);

      if (shippingDocuments.length > 0) {
        shippingDocuments.forEach((file) => {
          formData.append('shippingDocuments', file);
        });
      }

      const response = await axios.post(`${API_BASE_URL}/api/mark-order-shipped/${selectedInvoice.order_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.message) {
        // Remove the shipped order from the list (since it's no longer "In Production")
        setInvoices(invoices.filter(inv => inv.order_id !== selectedInvoice.order_id));
        alert(`Order ${selectedInvoice.order_id} has been marked as shipped and an invoice has been created.`);
        toggleShippingModal();
      }
    } catch (err) {
      console.error('Error marking order as shipped:', err);
      alert(`Failed to mark order as shipped: ${err.response?.data?.error || err.message}`);
    } finally {
      setShippingOrder(null);
    }
  };

  const handleEditShippedDate = (invoice) => {
    setEditingShippedDate(invoice.invoice_id);
    // Convert the date to YYYY-MM-DD format for the input
    const date = new Date(invoice.shipped_date);
    const formattedDate = date.toISOString().split('T')[0];
    setNewShippedDate(formattedDate);
  };

  const handleCancelEditShippedDate = () => {
    setEditingShippedDate(null);
    setNewShippedDate('');
  };

  const handleSaveShippedDate = async (invoice) => {
    if (!newShippedDate) {
      alert('Please select a shipped date');
      return;
    }

    try {
      // Get the order ID from the invoice
      const orderId = invoice.invoice_id.replace('INV-', 'ORD-');

      await axios.post(`${API_BASE_URL}/api/update-shipped-date/${orderId}`, {
        shippedDate: newShippedDate
      });

      // Update local data
      const updatedInvoices = invoices.map(inv => {
        if (inv.invoice_id === invoice.invoice_id) {
          return {
            ...inv,
            shipped_date: newShippedDate
          };
        }
        return inv;
      });

      setInvoices(updatedInvoices);
      setEditingShippedDate(null);
      setNewShippedDate('');
      alert('Shipped date updated successfully!');
    } catch (err) {
      console.error(err);
      alert('Error updating shipped date: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleEditInvoiceDate = (invoice) => {
    setEditingInvoiceDate(invoice.invoice_id);
    // Convert the date to YYYY-MM-DD format for the input
    const dateToUse = invoice.invoice_date || invoice.created_date;
    const date = new Date(dateToUse);
    const formattedDate = date.toISOString().split('T')[0];
    setNewInvoiceDate(formattedDate);
  };

  const handleCancelEditInvoiceDate = () => {
    setEditingInvoiceDate(null);
    setNewInvoiceDate('');
  };

  const handleSaveInvoiceDate = async (invoice) => {
    if (!newInvoiceDate) {
      alert('Please select an invoice date');
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/api/update-invoice-date/${invoice.invoice_id}`, {
        invoiceDate: newInvoiceDate
      });

      // Update local data
      const updatedInvoices = invoices.map(inv => {
        if (inv.invoice_id === invoice.invoice_id) {
          return {
            ...inv,
            invoice_date: newInvoiceDate
          };
        }
        return inv;
      });

      setInvoices(updatedInvoices);
      setEditingInvoiceDate(null);
      setNewInvoiceDate('');
      alert('Invoice date updated successfully!');
    } catch (err) {
      console.error(err);
      alert('Error updating invoice date: ' + (err.response?.data?.error || err.message));
    }
  };

  const toggleCreditNotePopover = (invoiceId) => {
    setCreditNotePopover(creditNotePopover === invoiceId ? null : invoiceId);
  };

  const handleUseCreditNote = async (creditNote, invoice) => {
    const cnCurrency = creditNote.currency || 'EUR';
    const invoiceCurrency = invoice.currency || 'EUR';
    const currencySymbol = getCurrencySymbol(cnCurrency);

    // Calculate converted amount if currencies differ
    let paymentAmount = parseFloat(creditNote.amount);
    if (cnCurrency !== invoiceCurrency) {
      const rate = customRates[creditNote.id] ? parseFloat(customRates[creditNote.id]) : getConversionRate(cnCurrency, invoiceCurrency);
      paymentAmount = parseFloat(creditNote.amount) * rate;
    }

    if (!window.confirm(`Apply credit note ${creditNote.credit_note_number} (${currencySymbol}${parseFloat(creditNote.amount).toFixed(2)}) as ${getCurrencySymbol(invoiceCurrency)}${paymentAmount.toFixed(2)} payment to invoice ${invoice.invoice_id}?`)) {
      return;
    }

    try {
      setApplyingCreditNote(creditNote.id);

      const response = await axios.post(`${API_BASE_URL}/api/apply-credit-note`, {
        invoiceId: invoice.invoice_id,
        orderId: invoice.invoice_id,
        creditNoteId: creditNote.id,
        creditNoteNumber: creditNote.credit_note_number,
        creditNotePdfUrl: creditNote.pdf_url,
        paymentAmount: paymentAmount,
        originalAmount: creditNote.amount,
        originalCurrency: cnCurrency,
        invoiceCurrency: invoiceCurrency,
        conversionRate: cnCurrency !== invoiceCurrency ? (customRates[creditNote.id] || getConversionRate(cnCurrency, invoiceCurrency)) : 1
      });

      // Refresh invoices to get updated payment status
      await fetchInvoices();

      alert(response.data.message || 'Credit note applied successfully!');
      toggleCreditNotePopover(invoice.invoice_id);
    } catch (err) {
      console.error('Error applying credit note:', err);
      alert('Error applying credit note: ' + (err.response?.data?.error || err.message));
    } finally {
      setApplyingCreditNote(null);
    }
  };

  if (loading) {
    return (
      <Fragment>
        <Breadcrumbs mainTitle="Invoices" parent="Orders" />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p className="mt-2">Loading invoices...</p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }

  if (error) {
    return (
      <Fragment>
        <Breadcrumbs mainTitle="Invoices" parent="Orders" />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody className="text-center">
                  <div className="alert alert-danger">
                    <h4>Error</h4>
                    <p>{error}</p>
                    <Button color="primary" onClick={fetchInvoices}>
                      Try Again
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Invoices" parent="Orders" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                  <div>
                    <h5>Orders In Production</h5>
                    <span>View and manage orders currently in production</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    {selectedInvoices.length > 0 && (
                      <Button
                        color="primary"
                        size="sm"
                        onClick={toggleDeliveryTagModalFn}
                      >
                        <Tag size={14} className="me-1" />
                        Assign Delivery Tag ({selectedInvoices.length})
                      </Button>
                    )}
                    {selectedInvoices.length > 0 && (
                      <Button
                        color="success"
                        size="sm"
                        onClick={handleDownloadGreenShipmentCSV}
                        title="Download Green shipment upload file for selected invoices"
                      >
                        <Download size={14} className="me-1" />
                        Green Shipment CSV ({selectedInvoices.length})
                      </Button>
                    )}
                    <Input
                      type="text"
                      placeholder="Search Invoice ID..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: '200px' }}
                    />
                    <Button color="primary" size="sm" onClick={handleDownloadReport} title="Download Report">
                      <Download size={16} className="me-1" />
                      Download Report
                    </Button>
                    <Button color="info" size="sm" onClick={handleDownloadSkuReport} title="Download SKU Report by Delivery Tags">
                      <Layers size={16} className="me-1" />
                      SKU Report
                    </Button>
                  </div>
                </div>
                <div className="status-tabs mt-3">
                  <style>{`
                    .status-tabs {
                      display: flex;
                      flex-wrap: wrap;
                      gap: 8px;
                    }
                    .status-tab {
                      padding: 6px 12px;
                      border-radius: 20px;
                      cursor: pointer;
                      font-size: 13px;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    }
                    .status-tab:hover {
                      opacity: 0.8;
                    }
                    .status-tab.active {
                      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                    }
                    .status-all { background: #e9ecef; color: #495057; }
                    .status-all.active { background: #495057; color: white; }
                    .status-in-production { background: #e2e3e5; color: #6c757d; }
                    .status-in-production.active { background: #6c757d; color: white; }
                    .status-invoice-generated { background: #d3d3d4; color: #343a40; }
                    .status-invoice-generated.active { background: #343a40; color: white; }
                    .status-ready-to-ship { background: #cff4fc; color: #055160; }
                    .status-ready-to-ship.active { background: #0dcaf0; color: white; }
                    .status-shipped { background: #cfe2ff; color: #084298; }
                    .status-shipped.active { background: #0d6efd; color: white; }
                    .status-delivered { background: #d1e7dd; color: #0f5132; }
                    .status-delivered.active { background: #198754; color: white; }
                    .status-fully-paid { background: #d1e7dd; color: #0f5132; }
                    .status-fully-paid.active { background: #198754; color: white; }
                    .status-deposit-paid { background: #cfe2ff; color: #084298; }
                    .status-deposit-paid.active { background: #0d6efd; color: white; }
                    .status-partially-paid { background: #fff3cd; color: #664d03; }
                    .status-partially-paid.active { background: #ffc107; color: #000; }
                    .status-unpaid { background: #e2e3e5; color: #6c757d; }
                    .status-unpaid.active { background: #6c757d; color: white; }

                    .delivery-tags-section {
                      margin-top: 12px;
                      padding-top: 12px;
                      border-top: 1px solid #dee2e6;
                    }
                    .delivery-tags-label {
                      font-size: 12px;
                      font-weight: 600;
                      color: #6c757d;
                      margin-bottom: 8px;
                      display: flex;
                      align-items: center;
                      gap: 6px;
                    }
                    .delivery-tag-tab { background: #e0f2fe; color: #0369a1; }
                    .delivery-tag-tab.active { background: #0ea5e9; color: white; }
                    .delivery-tag-tab.no-tag { background: #f3f4f6; color: #6b7280; }
                    .delivery-tag-tab.no-tag.active { background: #6b7280; color: white; }
                  `}</style>
                  <span
                    className={`status-tab status-all ${statusFilter === 'All' ? 'active' : ''}`}
                    onClick={() => setStatusFilter('All')}
                  >
                    All ({getStatusCounts().all})
                  </span>
                  {getStatusCounts()['Invoice Generated'] > 0 && (
                    <span
                      className={`status-tab status-invoice-generated ${statusFilter === 'Invoice Generated' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Invoice Generated')}
                    >
                      Invoice Generated ({getStatusCounts()['Invoice Generated']})
                    </span>
                  )}
                  {getStatusCounts()['In Production'] > 0 && (
                    <span
                      className={`status-tab status-in-production ${statusFilter === 'In Production' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('In Production')}
                    >
                      In Production ({getStatusCounts()['In Production']})
                    </span>
                  )}
                  {getStatusCounts()['Ready to Ship'] > 0 && (
                    <span
                      className={`status-tab status-ready-to-ship ${statusFilter === 'Ready to Ship' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Ready to Ship')}
                    >
                      Ready to Ship ({getStatusCounts()['Ready to Ship']})
                    </span>
                  )}
                  {getStatusCounts()['Shipped'] > 0 && (
                    <span
                      className={`status-tab status-shipped ${statusFilter === 'Shipped' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Shipped')}
                    >
                      Shipped ({getStatusCounts()['Shipped']})
                    </span>
                  )}
                  {getStatusCounts()['Delivered'] > 0 && (
                    <span
                      className={`status-tab status-delivered ${statusFilter === 'Delivered' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Delivered')}
                    >
                      Delivered ({getStatusCounts()['Delivered']})
                    </span>
                  )}
                  {getStatusCounts()['Fully Paid'] > 0 && (
                    <span
                      className={`status-tab status-fully-paid ${statusFilter === 'Fully Paid' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Fully Paid')}
                    >
                      Fully Paid ({getStatusCounts()['Fully Paid']})
                    </span>
                  )}
                  {getStatusCounts()['Deposit Paid'] > 0 && (
                    <span
                      className={`status-tab status-deposit-paid ${statusFilter === 'Deposit Paid' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Deposit Paid')}
                    >
                      Deposit Paid ({getStatusCounts()['Deposit Paid']})
                    </span>
                  )}
                  {getStatusCounts()['Partially Paid'] > 0 && (
                    <span
                      className={`status-tab status-partially-paid ${statusFilter === 'Partially Paid' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Partially Paid')}
                    >
                      Partially Paid ({getStatusCounts()['Partially Paid']})
                    </span>
                  )}
                  {getStatusCounts()['Unpaid'] > 0 && (
                    <span
                      className={`status-tab status-unpaid ${statusFilter === 'Unpaid' ? 'active' : ''}`}
                      onClick={() => setStatusFilter('Unpaid')}
                    >
                      Unpaid ({getStatusCounts()['Unpaid']})
                    </span>
                  )}
                </div>

                {/* Delivery Tag Tabs */}
                <div className="delivery-tags-section">
                  <div className="delivery-tags-label">
                    <Tag size={14} />
                    Delivery Tags:
                  </div>
                  <div className="status-tabs">
                    <span
                      className={`status-tab delivery-tag-tab ${deliveryTagFilter === 'All' ? 'active' : ''}`}
                      onClick={() => setDeliveryTagFilter('All')}
                    >
                      All ({getDeliveryTagCounts().all})
                    </span>
                    <span
                      className={`status-tab delivery-tag-tab no-tag ${deliveryTagFilter === 'None' ? 'active' : ''}`}
                      onClick={() => setDeliveryTagFilter('None')}
                    >
                      No Tag ({getDeliveryTagCounts().none})
                    </span>
                    {deliveryTags.map(tag => (
                      getDeliveryTagCounts()[tag.id] > 0 && (
                        <span
                          key={tag.id}
                          className={`status-tab delivery-tag-tab ${deliveryTagFilter === tag.id.toString() ? 'active' : ''}`}
                          onClick={() => setDeliveryTagFilter(tag.id.toString())}
                        >
                          {tag.name} - {tag.month} ({getDeliveryTagCounts()[tag.id]})
                        </span>
                      )
                    ))}
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                {getFilteredInvoices().length === 0 ? (
                  <div className="text-center py-4">
                    <h4>{(statusFilter !== 'All' || deliveryTagFilter !== 'All' || searchQuery) ? 'No Matching Orders' : 'No Orders In Production'}</h4>
                    <p>{(statusFilter !== 'All' || deliveryTagFilter !== 'All' || searchQuery) ? 'No orders match your filter criteria.' : 'No orders are currently in production. Orders appear here when their status is set to "In Production".'}</p>
                    {(statusFilter !== 'All' || deliveryTagFilter !== 'All' || searchQuery) && (
                      <Button color="secondary" size="sm" onClick={() => { setStatusFilter('All'); setDeliveryTagFilter('All'); setSearchQuery(''); }}>
                        Clear Filters
                      </Button>
                    )}
                  </div>
                ) : (
                  <div className="table-responsive">
                    <style>{tableStyles}</style>
                    <Table striped hover className="invoices-table">
                      <thead>
                        <tr>
                          <th style={{ width: '40px' }}>
                            <Input
                              type="checkbox"
                              checked={selectedInvoices.length === getFilteredInvoices().length && getFilteredInvoices().length > 0}
                              onChange={() => handleSelectAll(getFilteredInvoices())}
                            />
                          </th>
                          <th className="sortable-header" onClick={() => handleSort('invoice_id')}>
                            Invoice ID{getSortIndicator('invoice_id')}
                          </th>
                          <th>Invoice Date</th>
                          <th>Total Amount</th>
                          <th>Status</th>
                          <th>Payment</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getSortedInvoices(getFilteredInvoices()).map((invoice) => (
                          <tr key={invoice.invoice_id} className={selectedInvoices.includes(invoice.invoice_id) ? 'selected-row' : ''}>
                            <td>
                              <Input
                                type="checkbox"
                                checked={selectedInvoices.includes(invoice.invoice_id)}
                                onChange={() => handleSelectInvoice(invoice.invoice_id)}
                              />
                            </td>
                            <td>
                              <div>
                                <div className="d-flex align-items-center gap-2">
                                  <a
                                    href={`/faraadmin/collection-order-form/${invoice.invoice_id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="invoice-id-link"
                                    style={{
                                      color: '#007bff',
                                      textDecoration: 'none',
                                      fontWeight: 'bold'
                                    }}
                                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                  >
                                    {invoice.invoice_id}
                                  </a>
                                  {invoice.invoice_generated === 1 && (
                                    <Badge color="dark" style={{ fontSize: '10px' }}>Invoice Generated</Badge>
                                  )}
                                </div>
                                {invoice.delivery_tag_name && (
                                  <div className="mt-1">
                                    <Badge color="info" pill className="delivery-tag-badge">
                                      <Tag size={10} className="me-1" />
                                      {invoice.delivery_tag_name} - {invoice.delivery_tag_month}
                                    </Badge>
                                  </div>
                                )}
                                <div className="mt-1">
                                  <div className="d-flex align-items-center gap-2">
                                    <span style={{ fontWeight: '500' }}>{invoice.store_name || 'N/A'}</span>
                                  </div>
                                  {invoice.vat_eori && (
                                    <small className="text-muted">{invoice.vat_eori}</small>
                                  )}
                                  <div className="d-flex align-items-center gap-2">
                                    {invoice.customer_id && customerCreditNotes[invoice.customer_id] && customerCreditNotes[invoice.customer_id].length > 0 && (
                                    <>
                                      <FileText
                                        id={`credit-note-${invoice.invoice_id}`}
                                        size={16}
                                        style={{ cursor: 'pointer', color: '#28a745' }}
                                        onClick={() => toggleCreditNotePopover(invoice.invoice_id)}
                                        title="Credit Notes Available"
                                      />
                                      <Popover
                                        placement="right"
                                        isOpen={creditNotePopover === invoice.invoice_id}
                                        target={`credit-note-${invoice.invoice_id}`}
                                        toggle={() => toggleCreditNotePopover(invoice.invoice_id)}
                                      >
                                        <PopoverHeader>
                                          Credit Notes for {invoice.store_name}
                                        </PopoverHeader>
                                        <PopoverBody>
                                          {customerCreditNotes[invoice.customer_id].map(cn => {
                                            const cnCurrency = cn.currency || 'EUR';
                                            const invoiceCurrency = invoice.currency || 'EUR';
                                            const currencyMismatch = cnCurrency !== invoiceCurrency;
                                            const defaultRate = currencyMismatch ? getConversionRate(cnCurrency, invoiceCurrency) : 1;

                                            // Get the active rate (custom or default)
                                            const activeRate = customRates[cn.id] ? parseFloat(customRates[cn.id]) : defaultRate;
                                            const convertedAmount = parseFloat(cn.amount) * activeRate;

                                            return (
                                              <div key={cn.id} className="mb-3 pb-3 border-bottom">
                                                <div><strong>CR #:</strong> {cn.credit_note_number}</div>
                                                <div>
                                                  <strong>Amount:</strong> {getCurrencySymbol(cnCurrency)}{parseFloat(cn.amount).toFixed(2)}
                                                  {currencyMismatch && (
                                                    <div className="mt-2">
                                                      {editingRate === cn.id ? (
                                                        <div className="d-flex align-items-center gap-2 mb-2">
                                                          <span className="text-muted small">Rate: 1 {cnCurrency} =</span>
                                                          <Input
                                                            type="number"
                                                            step="0.01"
                                                            value={customRates[cn.id] !== undefined ? customRates[cn.id] : defaultRate}
                                                            onChange={(e) => {
                                                              const newRate = e.target.value;
                                                              setCustomRates({
                                                                ...customRates,
                                                                [cn.id]: newRate
                                                              });
                                                            }}
                                                            onBlur={(e) => {
                                                              // Format to 2 decimal places when user leaves the field
                                                              if (e.target.value) {
                                                                const formatted = parseFloat(e.target.value).toFixed(2);
                                                                setCustomRates({
                                                                  ...customRates,
                                                                  [cn.id]: formatted
                                                                });
                                                              }
                                                            }}
                                                            style={{ width: '100px' }}
                                                            className="form-control form-control-sm"
                                                          />
                                                          <span className="text-muted small">{invoiceCurrency}</span>
                                                          <Check
                                                            size={16}
                                                            style={{ cursor: 'pointer', color: '#28a745' }}
                                                            onClick={() => setEditingRate(null)}
                                                            title="Save"
                                                          />
                                                          <X
                                                            size={16}
                                                            style={{ cursor: 'pointer', color: '#dc3545' }}
                                                            onClick={() => {
                                                              setCustomRates({
                                                                ...customRates,
                                                                [cn.id]: undefined
                                                              });
                                                              setEditingRate(null);
                                                            }}
                                                            title="Cancel"
                                                          />
                                                        </div>
                                                      ) : (
                                                        <div className="text-muted small mb-1 d-flex align-items-center gap-2">
                                                          <span>
                                                            Rate: 1 {cnCurrency} = {activeRate.toFixed(2)} {invoiceCurrency}
                                                            {customRates[cn.id] && <span className="text-success"> (custom)</span>}
                                                          </span>
                                                          <Edit2
                                                            size={14}
                                                            style={{ cursor: 'pointer', color: '#007bff' }}
                                                            onClick={() => setEditingRate(cn.id)}
                                                            title="Edit rate"
                                                          />
                                                        </div>
                                                      )}
                                                      <div className="input-group input-group-sm mb-2">
                                                        <span className="input-group-text">Custom {invoiceCurrency}</span>
                                                        <Input
                                                          type="number"
                                                          step="0.01"
                                                          value={convertedAmount.toFixed(2)}
                                                          readOnly
                                                          style={{ maxWidth: '120px' }}
                                                        />
                                                      </div>
                                                      {customRates[cn.id] && (
                                                        <div className="text-info small">
                                                          Calculated rate: 1 {cnCurrency} = {activeRate.toFixed(2)} {invoiceCurrency}
                                                        </div>
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                                <div className="mb-2">
                                                  <a href={cn.pdf_url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary mt-1">
                                                    <FileText size={12} className="me-1" />
                                                    View PDF
                                                  </a>
                                                </div>
                                                <Button
                                                  color="success"
                                                  size="sm"
                                                  onClick={() => handleUseCreditNote(cn, invoice)}
                                                  disabled={applyingCreditNote === cn.id}
                                                >
                                                  {applyingCreditNote === cn.id ? (
                                                    <>
                                                      <Spinner size="sm" className="me-1" />
                                                      Applying, please wait...
                                                    </>
                                                  ) : (
                                                    'Use Credit Note'
                                                  )}
                                                </Button>
                                              </div>
                                            );
                                          })}
                                        </PopoverBody>
                                      </Popover>
                                    </>
                                  )}
                                  </div>
                                  {editingShippedDate === invoice.invoice_id ? (
                                    <div className="d-flex align-items-center gap-1 mt-1">
                                      <Input
                                        type="date"
                                        value={newShippedDate}
                                        onChange={(e) => setNewShippedDate(e.target.value)}
                                        size="sm"
                                        style={{ width: '150px' }}
                                      />
                                      <Button
                                        color="success"
                                        size="sm"
                                        onClick={() => handleSaveShippedDate(invoice)}
                                        title="Save"
                                      >
                                        <i className="fa fa-check"></i>
                                      </Button>
                                      <Button
                                        color="secondary"
                                        size="sm"
                                        onClick={handleCancelEditShippedDate}
                                        title="Cancel"
                                      >
                                        <i className="fa fa-times"></i>
                                      </Button>
                                    </div>
                                  ) : (
                                    <small className="text-muted d-block">
                                      Shipped: {formatDate(invoice.shipped_date)}
                                      <i
                                        className="fa fa-pencil ms-2"
                                        style={{ cursor: 'pointer', color: '#007bff' }}
                                        onClick={() => handleEditShippedDate(invoice)}
                                        title="Edit shipped date"
                                      ></i>
                                    </small>
                                  )}
                                  {invoice.is_delivered === 1 && (
                                    <small className="text-muted d-block">Delivered: {formatDate(invoice.delivered_date)}</small>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              {editingInvoiceDate === invoice.invoice_id ? (
                                <div className="d-flex align-items-center gap-1">
                                  <Input
                                    type="date"
                                    value={newInvoiceDate}
                                    onChange={(e) => setNewInvoiceDate(e.target.value)}
                                    size="sm"
                                    style={{ width: '150px' }}
                                  />
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={() => handleSaveInvoiceDate(invoice)}
                                    title="Save"
                                  >
                                    <i className="fa fa-check"></i>
                                  </Button>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    onClick={handleCancelEditInvoiceDate}
                                    title="Cancel"
                                  >
                                    <i className="fa fa-times"></i>
                                  </Button>
                                </div>
                              ) : (
                                <span style={{ cursor: 'pointer' }} onClick={() => handleEditInvoiceDate(invoice)}>
                                  {formatDate(invoice.invoice_date || invoice.created_date)}
                                  <i
                                    className="fa fa-pencil ms-2"
                                    style={{ color: '#007bff' }}
                                    title="Edit invoice date"
                                  ></i>
                                </span>
                              )}
                            </td>
                            <td>
                              <div>
                                <strong>{formatInvoiceCurrency(invoice, invoice.total_amount)}</strong>
                                <Edit2
                                  size={13}
                                  style={{ cursor: 'pointer', color: '#007bff', marginLeft: '6px' }}
                                  title="Change display currency"
                                  onClick={() => handleOpenCurrencyModal(invoice)}
                                />
                                {invoice.display_currency && invoice.display_currency !== invoice.currency && (
                                  <Badge color="info" style={{ fontSize: '10px' }} className="ms-1">
                                    shown in {invoice.display_currency}
                                  </Badge>
                                )}
                                {invoice.deposit_value && (
                                  <div className="mt-1">
                                    <Badge color="success" style={{ fontSize: '11px' }}>
                                      Deposit: {invoice.deposit_type === 'percentage'
                                        ? `${invoice.deposit_value}% (${formatInvoiceCurrency(invoice, (parseFloat(invoice.deposit_value) / 100) * (parseFloat(invoice.total_amount) - parseFloat(invoice.shipping_cost || 50)))})`
                                        : formatInvoiceCurrency(invoice, invoice.deposit_value)
                                      }
                                    </Badge>
                                  </div>
                                )}
                              </div>
                            </td>
                            <td>
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  caret
                                  color={getStatusColor(invoice.order_status || 'Shipped')}
                                  size="sm"
                                  style={{ minWidth: '130px' }}
                                >
                                  {invoice.order_status || 'Shipped'}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'New Order')}
                                    active={invoice.order_status === 'New Order'}
                                  >
                                    <Badge color="primary" className="me-2">●</Badge>
                                    New Order
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'In Production')}
                                    active={invoice.order_status === 'In Production'}
                                  >
                                    <Badge color="secondary" className="me-2">●</Badge>
                                    In Production
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'Ready to Ship')}
                                    active={invoice.order_status === 'Ready to Ship'}
                                  >
                                    <Badge color="info" className="me-2">●</Badge>
                                    Ready to Ship
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'Shipped')}
                                    active={invoice.order_status === 'Shipped' || !invoice.order_status}
                                  >
                                    <Badge color="info" className="me-2">●</Badge>
                                    Shipped
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'Delivered')}
                                    active={invoice.order_status === 'Delivered'}
                                  >
                                    <Badge color="success" className="me-2">●</Badge>
                                    Delivered
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'Deposit Paid')}
                                    active={invoice.order_status === 'Deposit Paid'}
                                  >
                                    <Badge color="warning" className="me-2">●</Badge>
                                    Deposit Paid
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'Paid in Full')}
                                    active={invoice.order_status === 'Paid in Full'}
                                  >
                                    <Badge color="success" className="me-2">●</Badge>
                                    Paid in Full
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleStatusChange(invoice, 'Cancelled')}
                                    active={invoice.order_status === 'Cancelled'}
                                  >
                                    <Badge color="danger" className="me-2">●</Badge>
                                    Cancelled
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                {invoice.is_paid === 1 ? (
                                  <Badge color="success">Fully Paid</Badge>
                                ) : (invoice.total_paid || 0) > 0 ? (
                                  invoice.order_status === 'Deposit Paid' ? (
                                    <Badge color="primary">Deposit Paid</Badge>
                                  ) : (
                                    <Badge color="warning">Partially Paid</Badge>
                                  )
                                ) : (
                                  <Badge color="secondary">Unpaid</Badge>
                                )}
                                {(invoice.total_paid || 0) > 0 && (
                                  <>
                                    <Eye
                                      id={`payment-history-${invoice.invoice_id}`}
                                      size={16}
                                      style={{ cursor: 'pointer', color: '#007bff' }}
                                      onClick={() => togglePaymentHistoryPopover(invoice.invoice_id)}
                                      title="View Payment History"
                                    />
                                    <Popover
                                      placement="left"
                                      isOpen={paymentHistoryPopover === invoice.invoice_id}
                                      target={`payment-history-${invoice.invoice_id}`}
                                      toggle={() => setPaymentHistoryPopover(null)}
                                    >
                                      <PopoverHeader>Payment History</PopoverHeader>
                                      <PopoverBody style={{ minWidth: '280px', maxHeight: '300px', overflowY: 'auto' }}>
                                        {loadingPayments === invoice.invoice_id ? (
                                          <div className="text-center py-2">
                                            <Spinner size="sm" /> Loading...
                                          </div>
                                        ) : invoicePayments[invoice.invoice_id]?.length > 0 ? (
                                          invoicePayments[invoice.invoice_id].map((payment, idx) => (
                                            <div key={payment.id || idx} className="border-bottom pb-2 mb-2">
                                              <div className="d-flex justify-content-between">
                                                <strong>{formatInvoiceCurrency(invoice, payment.payment_amount)}</strong>
                                                <small className="text-muted">{formatDate(payment.payment_date)}</small>
                                              </div>
                                              {payment.payment_type && (
                                                <Badge color="info" size="sm" className="me-1">{payment.payment_type}</Badge>
                                              )}
                                              {payment.notes && (
                                                <small className="text-muted d-block mt-1">{payment.notes}</small>
                                              )}
                                              {payment.proof_of_payment && (
                                                <a
                                                  href={typeof payment.proof_of_payment === 'string' && payment.proof_of_payment.startsWith('{')
                                                    ? JSON.parse(payment.proof_of_payment).webViewLink
                                                    : payment.proof_of_payment}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="small"
                                                >
                                                  View Proof
                                                </a>
                                              )}
                                            </div>
                                          ))
                                        ) : (
                                          <div className="text-muted text-center">No payments recorded</div>
                                        )}
                                      </PopoverBody>
                                    </Popover>
                                  </>
                                )}
                              </div>
                              {(invoice.total_paid || 0) > 0 && (
                                <small className="text-muted d-block mt-1">
                                  {formatInvoiceCurrency(invoice, invoice.total_paid)} / {formatInvoiceCurrency(invoice, invoice.total_amount)}
                                </small>
                              )}
                            </td>
                            <td>
                              <div className="d-flex flex-wrap gap-1">
                                {invoice.is_shipped !== 1 && (
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={() => handleMarkAsShipped(invoice)}
                                    disabled={shippingOrder === invoice.order_id}
                                    title="Mark as Shipped"
                                  >
                                    {shippingOrder === invoice.order_id ? (
                                      <i className="fa fa-spinner fa-spin"></i>
                                    ) : (
                                      <i className="fa fa-truck"></i>
                                    )}
                                  </Button>
                                )}
                                {invoice.is_delivered !== 1 && invoice.is_shipped === 1 && (
                                  <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => handleMarkDelivered(invoice)}
                                    title="Mark as Delivered"
                                  >
                                    <i className="fa fa-check-circle"></i>
                                  </Button>
                                )}
                                {invoice.is_paid !== 1 && (parseFloat(invoice.total_paid) || 0) < (parseFloat(invoice.total_amount) || 0) && (
                                  <Button
                                    color="warning"
                                    size="sm"
                                    onClick={() => handleMarkPaid(invoice)}
                                    title={(invoice.total_paid || 0) > 0 ? "Add Payment" : "Mark as Paid"}
                                  >
                                    <i className="fa fa-money"></i>
                                  </Button>
                                )}
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => handleDownloadPDF(invoice.invoice_id)}
                                  title="Download Invoice PDF"
                                >
                                  <i className="fa fa-file-pdf-o"></i>
                                </Button>
                                <Button
                                  color="dark"
                                  size="sm"
                                  onClick={() => handleDownloadPDFWithHSN(invoice.invoice_id)}
                                  title="Download Invoice PDF with HSN codes"
                                >
                                  <i className="fa fa-file-pdf-o"></i> HSN
                                </Button>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handleDownloadXLS(invoice.invoice_id)}
                                  title="Download Invoice XLS"
                                >
                                  <i className="fa fa-file-excel-o"></i>
                                </Button>
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => handleOpenCompanyModal(invoice)}
                                  title="Edit company details on this invoice"
                                >
                                  <i className="fa fa-building"></i>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Delivery Modal */}
      <Modal isOpen={deliveryModal} toggle={toggleDeliveryModal}>
        <ModalHeader toggle={toggleDeliveryModal}>
          Mark Invoice as Delivered - {selectedInvoice?.invoice_id}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="deliveryDate">Delivery Date *</Label>
              <Input
                type="date"
                name="deliveryDate"
                id="deliveryDate"
                value={deliveryDate}
                onChange={(e) => setDeliveryDate(e.target.value)}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="deliveryDocuments">Delivery Documents (Optional)</Label>
              <Input
                type="file"
                name="deliveryDocuments"
                id="deliveryDocuments"
                accept="image/*,application/pdf"
                onChange={(e) => setDeliveryDocuments(Array.from(e.target.files))}
                multiple
              />
              <small className="text-muted">
                Upload delivery documents (images or PDF). Multiple files allowed.
              </small>
              {deliveryDocuments.length > 0 && (
                <div className="mt-2">
                  <strong>Selected files ({deliveryDocuments.length}):</strong>
                  <ul className="mb-0 mt-1">
                    {deliveryDocuments.map((file, index) => (
                      <li key={index}><small>{file.name}</small></li>
                    ))}
                  </ul>
                </div>
              )}
            </FormGroup>
            <div className="alert alert-info mt-3 mb-0">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <strong>Payment Reminder:</strong> An automated email will be sent{' '}
                  <strong>{reminderSettings.reminder_days} days</strong> after delivery to{' '}
                  <strong>{reminderSettings.recipient_email || 'N/A'}</strong>
                  {!reminderSettings.enabled && <span className="text-danger"> (Currently disabled)</span>}
                </div>
                <Button
                  color="link"
                  size="sm"
                  className="p-0 ms-2"
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() => {
                    setShowReminderConfig(!showReminderConfig);
                    if (!showReminderConfig) fetchReminderLogs();
                  }}
                >
                  {showReminderConfig ? 'Hide' : 'Configure'}
                </Button>
              </div>
            </div>
            {showReminderConfig && (
              <div className="border rounded p-3 mt-3">
                <h6 className="mb-3">Payment Reminder Settings</h6>
                <FormGroup>
                  <Label for="reminderDays">Send reminder after (days)</Label>
                  <Input
                    type="number"
                    id="reminderDays"
                    min="1"
                    max="365"
                    value={reminderSettings.reminder_days}
                    onChange={(e) => setReminderSettings({ ...reminderSettings, reminder_days: parseInt(e.target.value) || 30 })}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="reminderEmail">Send to email</Label>
                  <Input
                    type="email"
                    id="reminderEmail"
                    value={reminderSettings.recipient_email}
                    onChange={(e) => setReminderSettings({ ...reminderSettings, recipient_email: e.target.value })}
                  />
                </FormGroup>
                <FormGroup check className="mb-3">
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={reminderSettings.enabled === 1 || reminderSettings.enabled === true}
                      onChange={(e) => setReminderSettings({ ...reminderSettings, enabled: e.target.checked ? 1 : 0 })}
                    />{' '}
                    Enable automatic payment reminders
                  </Label>
                </FormGroup>
                <Button color="success" size="sm" onClick={handleSaveReminderSettings} disabled={savingReminder}>
                  {savingReminder ? 'Saving...' : 'Save Settings'}
                </Button>

                {reminderLogs.length > 0 && (
                  <div className="mt-3">
                    <h6>Recent Reminder Logs</h6>
                    <Table size="sm" bordered responsive style={{ fontSize: '12px' }}>
                      <thead>
                        <tr>
                          <th>Invoice</th>
                          <th>Customer</th>
                          <th>Sent At</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reminderLogs.slice(0, 10).map((log) => (
                          <tr key={log.id}>
                            <td>{log.invoice_id}</td>
                            <td>{log.customer_name}</td>
                            <td>{new Date(log.reminder_sent_at).toLocaleString()}</td>
                            <td>
                              <Badge color={log.status === 'sent' ? 'success' : 'danger'}>
                                {log.status}
                              </Badge>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleDeliveryModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSaveDelivery}>
            Mark as Delivered
          </Button>
        </ModalFooter>
      </Modal>

      {/* Payment Modal */}
      <Modal isOpen={paymentModal} toggle={togglePaymentModal} size="lg">
        <ModalHeader toggle={togglePaymentModal}>
          Record Payment for Invoice - {selectedInvoice?.invoice_id}
        </ModalHeader>
        <ModalBody>
          <Form>
            {selectedInvoice && (
              // Deliberately native currency (selectedInvoice.currency), never the
              // display currency: this is the real amount a payment is recorded
              // against, and must match what the payment-amount field below accepts.
              <div className="mb-3 p-3 rounded" style={{ backgroundColor: '#7fba00' }}>
                <Row>
                  <Col md={4}>
                    <div className="text-center">
                      <small className="text-white">Invoice Total</small>
                      <h5 className="text-white mb-0">{formatCurrency(selectedInvoice.total_amount, selectedInvoice.currency)}</h5>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="text-center">
                      <small className="text-white">Already Paid</small>
                      <h5 className="text-white mb-0">{formatCurrency(selectedInvoice.total_paid || 0, selectedInvoice.currency)}</h5>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="text-center">
                      <small className="text-white">Remaining Balance</small>
                      <h5 className="text-white mb-0">{formatCurrency((selectedInvoice.total_amount || 0) - (selectedInvoice.total_paid || 0), selectedInvoice.currency)}</h5>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="paymentType">Payment Type *</Label>
                  <Input
                    type="select"
                    name="paymentType"
                    id="paymentType"
                    value={paymentType}
                    onChange={(e) => setPaymentType(e.target.value)}
                    required
                  >
                    <option value="">Select payment type</option>
                    <option value="Deposit">Deposit</option>
                    <option value="Advance">Advance</option>
                    <option value="Installment">Installment</option>
                    <option value="Full Payment">Full Payment</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="paymentAmount">Payment Amount ({selectedInvoice ? getCurrencySymbol(selectedInvoice.currency) : '€'}) *</Label>
                  <Input
                    type="number"
                    name="paymentAmount"
                    id="paymentAmount"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    step="0.01"
                    min="0.01"
                    max={selectedInvoice ? (selectedInvoice.total_amount || 0) - (selectedInvoice.total_paid || 0) : undefined}
                    required
                    placeholder="Enter payment amount"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="paymentDate">Payment Date *</Label>
                  <Input
                    type="date"
                    name="paymentDate"
                    id="paymentDate"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="proofOfPayment">Proof of Payment</Label>
                  <Input
                    type="file"
                    name="proofOfPayment"
                    id="proofOfPayment"
                    accept="image/*,application/pdf"
                    onChange={(e) => setProofOfPayment(e.target.files[0])}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="paymentNotes">Notes</Label>
                  <Input
                    type="textarea"
                    name="paymentNotes"
                    id="paymentNotes"
                    value={paymentNotes}
                    onChange={(e) => setPaymentNotes(e.target.value)}
                    rows="2"
                    placeholder="Add any notes about this payment (optional)"
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={togglePaymentModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSavePayment} disabled={savingPayment}>
            {savingPayment ? 'Saving...' : 'Record Payment'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Invoice Currency Modal */}
      <Modal isOpen={currencyModal} toggle={toggleCurrencyModal}>
        <ModalHeader toggle={toggleCurrencyModal}>
          Change Display Currency - {currencyModalInvoice?.invoice_id}
        </ModalHeader>
        <ModalBody>
          {currencyModalInvoice && (
            <Form>
              <p className="text-muted small">
                This invoice was raised in <strong>{currencyModalInvoice.currency || 'EUR'}</strong> and that
                remains the real amount owed and paid. Choosing a different currency here only changes how the
                total is <em>shown</em> on screen and on the printed/exported document, using the rate below.
              </p>
              <FormGroup>
                <Label for="targetCurrency">Show this invoice in</Label>
                <Input
                  type="select"
                  id="targetCurrency"
                  value={targetCurrency}
                  onChange={(e) => handleTargetCurrencyChange(e.target.value)}
                >
                  {['EUR', 'USD', 'GBP'].map((cur) => (
                    <option key={cur} value={cur}>
                      {cur}{cur === (currencyModalInvoice.currency || 'EUR') ? ' (native — no conversion)' : ''}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              {targetCurrency !== (currencyModalInvoice.currency || 'EUR') && (
                <>
                  <FormGroup>
                    <Label for="targetRate">
                      Exchange rate (1 {currencyModalInvoice.currency || 'EUR'} = ? {targetCurrency})
                    </Label>
                    <Input
                      type="number"
                      id="targetRate"
                      step="0.0001"
                      min="0"
                      value={targetRate}
                      onChange={(e) => setTargetRate(e.target.value)}
                      placeholder="Enter today's rate"
                    />
                  </FormGroup>
                  {targetRate && parseFloat(targetRate) > 0 && (
                    <p className="text-muted small">
                      Total will show as{' '}
                      <strong>
                        {formatCurrency(
                          (parseFloat(currencyModalInvoice.total_amount) || 0) * parseFloat(targetRate),
                          targetCurrency
                        )}
                      </strong>{' '}
                      (real amount: {formatCurrency(currencyModalInvoice.total_amount, currencyModalInvoice.currency)}).
                    </p>
                  )}
                </>
              )}
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleCurrencyModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSaveInvoiceCurrency} disabled={savingInvoiceCurrency}>
            {savingInvoiceCurrency ? 'Saving...' : 'Save'}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={companyModal} toggle={toggleCompanyModal} size="lg">
        <ModalHeader toggle={toggleCompanyModal}>
          Edit Company Details - {companyModalInvoice?.invoice_id}
        </ModalHeader>
        <ModalBody>
          {loadingCompany ? (
            <div className="text-center py-3"><Spinner size="sm" /> <span className="text-muted ms-1">Loading…</span></div>
          ) : (
            <Form>
              <p className="text-muted small">
                These fields override the global Company Settings for <strong>this invoice only</strong> — every
                other invoice keeps using the global values. Leave a field blank to keep using the global value
                (shown as a placeholder below).
              </p>
              <FormGroup>
                <Label for="companyName">Company Name</Label>
                <Input
                  id="companyName"
                  value={companyForm.company_name || ''}
                  onChange={(e) => setCompanyForm((f) => ({ ...f, company_name: e.target.value }))}
                  placeholder={companyGlobal.company_name || 'FARA BOUTIQUE'}
                />
              </FormGroup>
              <FormGroup>
                <Label for="companyAddress">Address</Label>
                <Input
                  id="companyAddress"
                  type="textarea"
                  rows="3"
                  value={companyForm.company_address || ''}
                  onChange={(e) => setCompanyForm((f) => ({ ...f, company_address: e.target.value }))}
                  placeholder={companyGlobal.address || ''}
                />
              </FormGroup>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="companyEmail">Email</Label>
                    <Input
                      id="companyEmail"
                      value={companyForm.company_email || ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_email: e.target.value }))}
                      placeholder={companyGlobal.email || ''}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="companyVat">VAT No</Label>
                    <Input
                      id="companyVat"
                      value={companyForm.company_vat_no || ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_vat_no: e.target.value }))}
                      placeholder={companyGlobal.vat_no || ''}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="companyEori">EORI</Label>
                    <Input
                      id="companyEori"
                      value={companyForm.company_eori || ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_eori: e.target.value }))}
                      placeholder={companyGlobal.eori || ''}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="companyReverseVat">Reverse VAT Charge (%)</Label>
                    <Input
                      id="companyReverseVat"
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      value={companyForm.company_reverse_vat_charge || ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_reverse_vat_charge: e.target.value }))}
                      placeholder={companyGlobal.reverse_vat_charge != null ? String(companyGlobal.reverse_vat_charge) : '0'}
                      disabled={companyForm.company_zero_rated_goods === '1'}
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="companyZeroRated">Zero-rated goods</Label>
                    <Input
                      id="companyZeroRated"
                      type="select"
                      value={companyForm.company_zero_rated_goods ?? ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_zero_rated_goods: e.target.value }))}
                    >
                      <option value="">
                        Use company setting ({Number(companyGlobal.zero_rated_goods) ? 'Zero-rated' : 'Not zero-rated'})
                      </option>
                      <option value="1">Zero-rated (0% VAT)</option>
                      <option value="0">Not zero-rated</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label for="companyBank">Bank Details</Label>
                    <Input
                      id="companyBank"
                      type="textarea"
                      rows="5"
                      value={companyForm.company_bank_details || ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_bank_details: e.target.value }))}
                      placeholder={companyGlobal.bank_details || ''}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label for="companyFiscal">Fiscal Representative</Label>
                    <Input
                      id="companyFiscal"
                      type="textarea"
                      rows="5"
                      value={companyForm.company_fiscal_rep || ''}
                      onChange={(e) => setCompanyForm((f) => ({ ...f, company_fiscal_rep: e.target.value }))}
                      placeholder={companyGlobal.fiscal_rep || ''}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleCompanyModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSaveCompanyDetails} disabled={savingCompany || loadingCompany}>
            {savingCompany ? 'Saving...' : 'Save'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Shipping Modal */}
      <Modal isOpen={shippingModal} toggle={toggleShippingModal}>
        <ModalHeader toggle={toggleShippingModal}>
          Mark Order as Shipped - {selectedInvoice?.order_id}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="shippingDate">Shipping Date *</Label>
              <Input
                type="date"
                name="shippingDate"
                id="shippingDate"
                value={shippingDate}
                onChange={(e) => setShippingDate(e.target.value)}
                required
              />
              <small className="text-muted d-block mt-1">
                This will convert the Proforma Invoice to an Invoice.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="trackingLink">Shipping/Tracking Link (Optional)</Label>
              <Input
                type="url"
                name="trackingLink"
                id="trackingLink"
                placeholder="https://..."
                value={trackingLink}
                onChange={(e) => setTrackingLink(e.target.value)}
              />
              <small className="text-muted">
                Enter the tracking URL from the shipping carrier.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="shippingDocuments">Shipping Documents (Optional)</Label>
              <Input
                type="file"
                name="shippingDocuments"
                id="shippingDocuments"
                accept="image/*,application/pdf"
                onChange={(e) => setShippingDocuments(Array.from(e.target.files))}
                multiple
              />
              <small className="text-muted">
                Upload shipping documents (images or PDF). Multiple files allowed.
              </small>
              {shippingDocuments.length > 0 && (
                <div className="mt-2">
                  <strong>Selected files ({shippingDocuments.length}):</strong>
                  <ul className="mb-0 mt-1">
                    {shippingDocuments.map((file, index) => (
                      <li key={index}><small>{file.name}</small></li>
                    ))}
                  </ul>
                </div>
              )}
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleShippingModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSaveShipping}>
            Mark as Shipped
          </Button>
        </ModalFooter>
      </Modal>

      {/* Delivery Tag Modal */}
      <Modal isOpen={deliveryTagModal} toggle={toggleDeliveryTagModalFn}>
        <ModalHeader toggle={toggleDeliveryTagModalFn}>
          Assign Delivery Tag to {selectedInvoices.length} Invoice{selectedInvoices.length !== 1 ? 's' : ''}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Selected Invoices:</Label>
              <div className="mb-3 p-2 bg-light rounded" style={{ maxHeight: '100px', overflowY: 'auto' }}>
                {selectedInvoices.map((invoiceId) => (
                  <Badge key={invoiceId} color="secondary" className="me-1 mb-1">{invoiceId}</Badge>
                ))}
              </div>
            </FormGroup>

            {!showNewTagForm ? (
              <>
                <FormGroup>
                  <Label for="deliveryTag">Select Delivery Tag</Label>
                  <Input
                    type="select"
                    name="deliveryTag"
                    id="deliveryTag"
                    value={selectedDeliveryTag}
                    onChange={(e) => setSelectedDeliveryTag(e.target.value)}
                  >
                    <option value="">-- Remove Delivery Tag --</option>
                    {deliveryTags.map(tag => (
                      <option key={tag.id} value={tag.id}>
                        {tag.name} ({tag.month})
                      </option>
                    ))}
                  </Input>
                </FormGroup>
                <Button
                  color="link"
                  size="sm"
                  onClick={() => setShowNewTagForm(true)}
                  className="p-0"
                >
                  <i className="fa fa-plus me-1"></i> Create New Delivery Tag
                </Button>
              </>
            ) : (
              <>
                <FormGroup>
                  <Label for="newTagName">Delivery Name *</Label>
                  <Input
                    type="text"
                    name="newTagName"
                    id="newTagName"
                    placeholder="e.g., Delivery 1, Delivery 2"
                    value={newTagName}
                    onChange={(e) => setNewTagName(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="newTagMonth">Month *</Label>
                  <Input
                    type="text"
                    name="newTagMonth"
                    id="newTagMonth"
                    placeholder="e.g., January 2025, Feb 2025"
                    value={newTagMonth}
                    onChange={(e) => setNewTagMonth(e.target.value)}
                  />
                </FormGroup>
                <div className="d-flex gap-2">
                  <Button color="success" size="sm" onClick={handleCreateNewTag}>
                    Create Tag
                  </Button>
                  <Button color="secondary" size="sm" onClick={() => {
                    setShowNewTagForm(false);
                    setNewTagName('');
                    setNewTagMonth('');
                  }}>
                    Cancel
                  </Button>
                </div>
              </>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleDeliveryTagModalFn}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAssignDeliveryTag} disabled={showNewTagForm}>
            {selectedDeliveryTag ? 'Assign Tag' : 'Remove Tag'}
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default Invoices;
